import React from 'react'

import firebase from 'gatsby-plugin-firebase'
import { parse } from 'query-string'

import Layout from '~/components/common/layout/layout'
import SEO from '~/components/common/layout/seo'
import Navigation from '~/components/common/navigation/navigation'
import BringCommunityTogether from '~/components/sections/BringCommunityTogether'
import Download from '~/components/sections/Download'
import Footer from '~/components/sections/Footer'
import Header from '~/components/sections/Header'
import ResiCarousel from '~/components/sections/resiCarousel'
import ResidentNumbers from '~/components/sections/ResidentNumbers'
import ResidentTestimonials from '~/components/sections/ResidentTestimonials'
import { Links } from '~/constants/links'

const Home: React.FC<HomeProps> = ({ login = false }) => {
  const carouselFirst = {
    title: 'put_residents_at_the_heart',
    text: 'residents_expect_more',
    items: [
      {
        icon: 'Suggestions',
        title: 'suggestions_title_text',
        text: 'things_can_always_be_better',
        buttonText: 'viewdetails',
        link: Links.FEATURES_SUGGESTIONS,
      },
      {
        icon: 'Requests',
        title: 'requests_title_text',
        text: 'think_of_resident',
        buttonText: 'viewdetails',
        link: Links.FEATURES_REQUESTS,
      },
      {
        icon: 'Appreciation',
        title: 'appreciation_title_text',
        text: 'we_all_love_to_complain',
        buttonText: 'viewdetails',
        link: Links.FEATURES_APPRECIATIONS,
      },
    ],
  }

  const carouselSecond = {
    title: 'allowing_cities_to_engage',
    text: 'traditional_social_media',
    items: [
      {
        icon: 'Alerts',
        title: 'alerts_live',
        text: 'theresidentappallowscitymanagers',
        buttonText: 'viewdetails',
        link: Links.FEATURES_ALERTS,
      },
      {
        icon: 'Proposals',
        title: 'proposals_title_text',
        text: 'electedofficialscanmeasure',
        buttonText: 'viewdetails',
        link: Links.FEATURES_PROPOSALS,
      },
      {
        icon: 'Events',
        title: 'events_title_text',
        text: 'residentscansubscribe',
        buttonText: 'viewdetails',
        link: Links.FEATURES_EVENTS,
      },
    ],
  }

  const carouselThird = {
    title: 'a_single_point',
    text: 'consumers_expect_everything',
    items: [
      {
        icon: 'Reports',
        title: 'reports_title_text',
        text: 'successwithresident',
      },
      {
        icon: 'Infrastructure',
        title: 'infrastructure_title_text',
        text: 'infrastructuredesc',
      },
      {
        icon: 'Vehicles',
        title: 'vehicles_title_text',
        text: 'feature_description_vehicle',
      },
      {
        icon: 'Assets',
        title: 'assets_title_text',
        text: 'feature_description_asset',
      },
      {
        icon: 'Worklogs',
        title: 'worklogs_live',
        text: 'feature_description_worklog',
      },
      {
        icon: 'Trips',
        title: 'trips_title_text',
        text: 'feature_description_trip',
      },
      {
        icon: 'Inspections',
        title: 'inspections_title_text',
        text: 'feature_description_inspection',
      },
      {
        icon: 'Tasks',
        title: 'tasks_live',
        text: 'feature_description_task_short',
      },
      {
        icon: 'Routes',
        title: 'routes_live',
        text: 'feature_description_route',
      },
      {
        icon: 'Playbooks',
        title: 'playbooks_live',
        text: 'feature_description_playbook',
      },
    ],
  }

  const track = () => {
    firebase.analytics().logEvent('facebook_home_clicked')
  }

  return (
    <Layout>
      <SEO title="home" />
      <Navigation login={login} />
      <Header />
      <ResidentNumbers />
      <BringCommunityTogether />
      <ResiCarousel
        className="blue-background"
        current="resi-first"
        data={carouselFirst}
      />
      <ResiCarousel
        className="white-background"
        current="resi-second"
        data={carouselSecond}
      />
      <ResiCarousel
        className="blue-background"
        current="resi-third"
        data={carouselThird}
      />
      <ResidentTestimonials />
      <Download />
      <Footer />
    </Layout>
  )
}

export default Home
